<div class="container vh-100 d-flex justify-content-center align-items-center">
  <div class="row justify-content-center w-100">
    <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
      <div class="card shadow-lg">
        <div class="card-body">
          <img src="assets/Images/CDM-01.png" alt="CDM Logo" class="d-flex img-fluid mb-4"
            style="max-height: 12%; height: auto; margin-left: 28%;">
          <h3 class="text-center mb-4" style="color: #8e0e00; font-weight: bold;">TD-CDM Account Deletion Form</h3>
          <p class="text-center">To delete your account, please confirm your phone number below.</p>
          <form [formGroup]="deletionForm">
            <div class="form-group">
              <label for="phoneNumber">Phone Number *</label>
              <input id="phoneNumber" type="text" class="form-control" maxlength="10"
                placeholder="Enter your phone number" formControlName="phoneNumber" required
                (keypress)="allowOnlyNumbers($event)" (input)="limitToTenDigits($event)" />
              <div *ngIf="phoneNumber?.invalid && phoneNumber?.touched" class="text-danger">
                <small *ngIf="phoneNumber?.errors?.['required']">Phone number is required.</small>
                <small *ngIf="phoneNumber?.errors?.['pattern']">Enter a valid phone number.</small>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <button type="submit" class="btn btn-danger mt-3" [disabled]="deletionForm.invalid"
                (click)="openConfirmationModal(confirmationModal)">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Content for Confirmation -->
<ng-template #confirmationModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title mt-3">Confirm Deletion</h4>
    <button type="button" class="btn-close" (click)="modal.dismiss()">
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this account?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="onSubmit(); modal.close()">Yes, Delete</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
  </div>
</ng-template>